import { SaveButton } from "components/Buttons"
import React from "react"

export default function Modal({
  isVisible,
  setIsVisible,
  deleteHandler,
  selectedMedia,
  deleteLoading,
}) {
  return (
    <div>
      <div
        className="modal fade show"
        role="dialog"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setIsVisible(false)
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <h5>
                  Are you sure you want to delete {selectedMedia?.length} media{" "}
                  {selectedMedia?.length === 1 ? "item" : "items"}?
                </h5>
              </div>
              <div className="mt-2 row">
                <div className="col">
                  <SaveButton
                    type="button"
                    color="danger"
                    content="Cancel"
                    onClick={() => {
                      setIsVisible(false)
                    }}
                    fullWidth={true}
                  />
                </div>
                <div className="col">
                <SaveButton
                    type="button"
                    content="Delete"
                    onClick={deleteHandler}
                    loading={deleteLoading}
                    fullWidth={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </div>
  )
}
